// Packages and components
import React from 'react';

// Styles
import { Selectable } from './SHDSelectable.styles';

// Types
import { SHDSelectableProps } from './SHDSelectable.d';

const SHDSelectable: React.FC<SHDSelectableProps> = React.memo(
  ({
    align = 'center',
    children,
    className = 'selectable',
    id,
    isActive,
    onSelected,
    pad = 'small',
    round,
  }: SHDSelectableProps) => {
    return (
      <Selectable
        align={align}
        className={`${className} ${className}-${id} ${isActive ? 'is-active' : ''}`}
        onClick={() => onSelected(id)}
        borderRadius={round}
        pad={pad}
      >
        {children}
      </Selectable>
    );
  }
);

export default SHDSelectable;
